import { matchPath } from 'react-router';

import {
  paidVisibilityRoutes,
  smartPromotionRoutes,
} from '@provider-portal/promotions-common/providers/apiClient/routes';

const CAMPAIGN_PAGES_WITH_SIGNUP_ID = [
  paidVisibilityRoutes.detail,
  paidVisibilityRoutes.costPerClickCampaignDetails,
  paidVisibilityRoutes.costPerClickCampaignEdit,
];

/**
 * These pages keep a signup id in history state. A provider switch reloads that same
 * URL, so the campaign is requested for the new provider and the page stays empty.
 * Leave for Promotions instead of reloading in place.
 */
export function resolveProviderSwitchLocation(pathname: string): string | null {
  const keepsSignupId = matchPath(pathname, {
    path: CAMPAIGN_PAGES_WITH_SIGNUP_ID,
    exact: true,
  });

  return keepsSignupId ? smartPromotionRoutes.promotions : null;
}
